<template>
    <div class="nav">
        <div class="logo">
            <router-link
                class="logo-link"
                :to="{ name: 'home' }"
                style="
                    background-image: url('/images/admin-ui/admin-kpam3d-emblema.svg');
                "
            >
            </router-link>
        </div>
        <router-link class="orders-link" :to="{ name: 'orders' }">
            <span class="orders-link__icon">
                <img src="/images/admin-ui/admin-zakaz.svg" alt="" />
            </span>
            <span class="orders-link__text">{{
                $t("admin.sidebar.orders")
            }}</span>
        </router-link>
        <div class="nav__right flex-1 py-2 wrapper-x-40 flex items-center">
            <div class="w-1/3">
                <input
                    type="text"
                    v-model="search"
                    class="rounded-sm h-8 w-64 p-4 focus:outline-none focus:ring text-gray-900 text-sm"
                    :placeholder="$t('admin.nav.search_placeholder')"
                    @keypress.enter="goToSearch"
                />
            </div>
            <div class="w-2/3 flex gap-3 text-sm items-center justify-end">
                <router-link
                    v-if="settings.with_calc_price == 0"
                    to="/?with_price=1"
                    target="_blank"
                    class="btn-front btn-with-price"
                >
                    <span class="btn-with-price-border">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="var(--ci-primary-color, currentColor)"
                                d="M291.75,308.1a105.8,105.8,0,1,0,0-211.6H136v32h39.943V276.1H136v32h39.943V352H136v32h39.943v56h32V384H304V352H207.943V308.1ZM207.943,128.5H291.75a73.8,73.8,0,1,1,0,147.6H207.943Z"
                                class="ci-primary"
                            />
                        </svg>
                    </span>
                    <span>{{ $t("admin.nav.front_panel_with_price") }}</span>
                </router-link>

                <router-link to="/" target="_blank" class="btn-front">
                    <span>{{ $t("admin.nav.front_part") }}</span>
                    <span
                        ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <g fill="none" fill-rule="evenodd">
                                <path
                                    d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8"
                                />
                            </g></svg
                    ></span>
                </router-link>
                <button @click="logout" class="btn-logout">
                    {{ $t("admin.nav.signout") }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Nav",
    data() {
        return {
            search: "",
        };
    },
    computed: {
        settings() {
            return this.$store.state.settings.settings;
        },
    },
    methods: {
        async logout() {
            try {
                // await axios.get("/api/admin/logout");
                localStorage.removeItem("auth_token");
                location.reload();
            } catch (error) {
                console.log(error);
            }
        },
        goToSearch() {
            this.$router.push({
                name: "AdminSearch",
                query: { search: this.search },
            });
        },
    },

    watch: {
        search(value) {
            this.$store.dispatch("adminSearch/setSearch", value);

            if (value.length >= 2 && this.$route.name == "AdminSearch") {
                this.$store.dispatch("adminSearch/fetch");
            }
        },
    },
};
</script>
<style scoped>
.nav {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 55px;
    z-index: 100;
    background-color: #fff;
}
.logo {
    background-color: #232435;
}
.logo-link {
    display: block;
    width: 55px;
    height: 100%;
    background: no-repeat;
    background-position: center center;
    background-size: 60%;
}
.orders-link {
    display: flex;
    align-items: center;
    column-gap: 10px;
    height: 55px;
    padding: 0 18px;
    background-color: #de1a1a;
    color: #fff;
    text-decoration: none;
}
.orders-link:hover {
    background-color: #b41515;
}
.orders-link__icon {
    width: 40px;
    height: 40px;
    display: grid;
    place-content: center;
}
.orders-link__icon img {
    width: 34px;
    height: 34px;
}
.orders-link__text {
    font-size: 20px;
    line-height: 1;
}
.nav__right {
    border-bottom: 1px solid #cfe2e8;
}
.nav__right input[type="text"] {
    border: 1px solid #cfe2e8;
}
.btn-front {
    height: 32px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    font-size: 14px;
    color: #fff;
    background-color: #059669;
    padding: 0 10px;
    border-radius: 2px;
}
.btn-front:hover {
    background-color: #044f38;
}
.btn-front.btn-with-price {
    background-color: #5089c9;
}
.btn-front.btn-with-price:hover {
    background-color: #2f4f73;
}
.btn-with-price-border {
    border: 1px solid #fff;
    height: 22px;
    width: 22px;
    display: grid;
    place-content: center;
    border-radius: 100%;
    padding: 2px;
}
.btn-with-price-border svg {
    height: 19px;
    width: 19px;
}
.btn-logout {
    border: none;
    background: none;
    background-color: #dc2626;
    color: #fff;
    font-size: 14px;
    border-radius: 2px;
    width: 80px;
    height: 32px;
    display: grid;
    place-content: center;
}
.btn-logout:hover {
    background-color: #7d1414;
}
</style>
